/*
 * @Author: yzr
 * @Date: 2020-12-07 10:58:27
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-07 10:59:36
 */
import DemoRender from './demo_render.vue';

export default DemoRender;
